/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Groupings for the settings in the permissions service
 */
export enum EnumFrontendLayoutSettingGroups {
    /**
     * Table layout customization settings.
     */
    TableLayout = 1,
}
